import { Category } from "../processors";
import React, { useContext } from "react";

interface ICategoryContext {
    category?: Category;
}

const defaultState = {
    category: undefined
};

export const CategoryContext = React.createContext<ICategoryContext>(defaultState);
export const useCategoryContext = () => useContext(CategoryContext);
